<template>
  <div class="debug-panel">
    Debug Panel
    <button @click="debugNewBet()">New Bet</button>
    <button @click="debugNewPlacedBet()">New Placed Bet</button>
    <br />
    <button @click="debugNewTicketRaffle()">New Ticket Raffle</button>
    <button @click="debugNewTicketRaffleEntry()">New Ticket Raffle Entry</button>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'debug',
  async created () {
  },
  data () {
    return {
    }
  },
  methods: {
    async debugNewTicketRaffle () {
      this.$store.commit('newTicketRaffle', {
        created_at: Date.now(),
        updated_at: Date.now(),
        id: Math.random() * 100,
        keyword: Math.floor(Math.random() * 100),
        price: Math.floor(Math.random() * 100)
      })
    },
    async debugNewTicketRaffleEntry () {
      let tr

      for (let b of this.$store.state.currentTicketRaffleIds) {
        if (this.$store.state.ticketRaffles[b]) {
          tr = this.$store.state.ticketRaffles[b]
          break
        }
      }

      if (tr) {
        if (this.$store.state.users.length === 0) {

        }

        // console.log('u', this.$store.state.users)
        // console.log('u2', Object.keys(this.$store.state.users)[0])

        this.$store.commit('newTicketRaffleEntry', {
          quantity: Math.floor(Math.random() * 10),
          user_id: this.$store.state.users[Object.keys(this.$store.state.users)[0]].id,
          ticket_raffle_id: tr.id
        })
      }
    },
    async debugNewPlacedBet () {
      let bet

      for (let b of this.$store.state.currentBetIds) {
        if (this.$store.state.bets[b]) {
          bet = this.$store.state.bets[b]
          break
        }
      }

      if (bet) {
        if (this.$store.state.users.length === 0) {

        }

        // console.log('u', this.$store.state.users)
        // console.log('u2', Object.keys(this.$store.state.users)[0])

        this.$store.commit('newPlacedBet', {bet: bet, bet_option: {}, placed_bet: {option: 0, amount: Math.floor(Math.random() * 10), user_id: this.$store.state.users[Object.keys(this.$store.state.users)[0]].id}})
      }
    },
    async debugNewBet () {
      this.$store.commit('newBet', {
        id: `${Math.random()}`,
        status: 1,
        created_at: moment(),
        options: [['a', 1], ['b', 1]],
        bet_options: [
          {
            option_number: 0,
            name: 'a',
            total: 0
          },
          {
            option_number: 1,
            name: 'b',
            total: 0
          }
        ]
      })
    }
  }
}
</script>

<style>
.debug-panel {
  position: fixed;
  right: 12px;
  bottom: 12px;
  z-index: 450;
  max-width: 280px;
  padding: 10px;
  text-align: right;
  font-family: var(--sl-font-cond);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--sl-dim);
  background: rgba(12, 12, 15, 0.9);
  border: 1px solid var(--sl-line-strong);
  border-radius: var(--sl-radius);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.debug-panel button {
  margin: 4px 0 0 4px;
  font-size: 11px;
  padding: 5px 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Debug-Panel.vue